import styled from 'styled-components'

export const WrapperImgCrop = styled.div`
  background: rgba(0, 0, 0, 0.5);
  height: 300px;
  width: 100%;
  position: relative;
  margin-bottom: 20px;
  @media (max-width: 767px) {
    height: 156px;
    margin-bottom: 30px;
  }
`
export const WrapperButton = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 50%;
  @media (max-width: 767px) {
    justify-content: center;
    margin-bottom: 15px;
    margin-top: 30px;
    width: 100%;
  }
`
export const WrapperZoom = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    width: 100%;
    padding: 0 15px;
  }
`

export const WrapperActions = styled.div`
  display: flex;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`
export const InputRange = styled.input`
  &[type='range'] {
    width: 100%;
    margin: 6px 0;
    background-color: transparent;
    -webkit-appearance: none;
  }
  &[type='range']:focus {
    outline: none;
  }
  &[type='range']::-webkit-slider-runnable-track {
    background: rgba(0, 108, 165, 0.5);
    border: 0px solid rgba(0, 0, 0, 0);
    border: 0;
    width: 100%;
    height: 2px;
    cursor: pointer;
  }
  &[type='range']::-webkit-slider-thumb {
    margin-top: -6px;
    width: 14px;
    height: 14px;
    background: #006ca5;
    border: 0px solid rgba(4, 0, 0, 0);
    border: 0;
    border-radius: 100px;
    cursor: pointer;
    -webkit-appearance: none;
  }
  &[type='range']:focus::-webkit-slider-runnable-track {
    background: rgba(0, 108, 165, 0.5);
  }
  &[type='range']::-moz-range-track {
    background: rgba(0, 108, 165, 0.5);
    border: 0px solid rgba(0, 0, 0, 0);
    border: 0;
    width: 100%;
    height: 2px;
    cursor: pointer;
  }
  &[type='range']::-moz-range-thumb {
    width: 14px;
    height: 14px;
    background: #006ca5;
    border: 0px solid rgba(4, 0, 0, 0);
    border: 0;
    border-radius: 100px;
    cursor: pointer;
  }
  &[type='range']::-ms-track {
    background: transparent;
    border-color: transparent;
    border-width: 6px 0;
    color: transparent;
    width: 100%;
    height: 2px;
    cursor: pointer;
  }
  &[type='range']::-ms-fill-lower {
    background: rgba(0, 108, 165, 0.5);
    border: 0px solid rgba(0, 0, 0, 0);
    border: 0;
  }
  &[type='range']::-ms-fill-upper {
    background: rgba(0, 108, 165, 0.5);
    border: 0px solid rgba(0, 0, 0, 0);
    border: 0;
  }
  &[type='range']::-ms-thumb {
    width: 14px;
    height: 14px;
    background: #006ca5;
    border: 0px solid rgba(4, 0, 0, 0);
    border: 0;
    border-radius: 100px;
    cursor: pointer;
    margin-top: 0px;
    /*Needed to keep the Edge thumb centred*/
  }
  &[type='range']:focus::-ms-fill-lower {
    background: rgba(0, 108, 165, 0.5);
  }
  &[type='range']:focus::-ms-fill-upper {
    background: rgba(0, 108, 165, 0.5);
  }
`

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.gray_1};
  font: 14px/18px 'DMSans-Regular';
  margin-right: 10px;
`
